export class Location {
    constructor(x, y) {
        this.x = x;
        this.y = y;
    }
    getX() {
        return this.x;
    }
    getY() {
        return this.y;
    }
    setX(x) {
        this.x = x;
    }
    setY(y) {
        this.y = y;
    }
    getRelativeLocation(x, y) {
        return new Location(this.x + x, this.y + y);
    }
    equalsLocation(l2) {
        return this.getX() === l2.getX() && this.getY() === l2.getY();
    }
}
